// extracted by mini-css-extract-plugin
export default {"container":"style_container__1iurG","icon":"style_icon__5RjLx"};